import styled from 'styled-components';
import { PrimaryButtonComponent, DataValue } from "../../../../../../CommonComponents/commonStyles";
import { TableLabel, GrantsTable, SubSectionLabel } from '../../style';

export const Text = styled.p`
 font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.primary};
 font-style: ${props => props.theme.fontWeight.normal};
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.zero};
 color: ${props => props.theme.fontColors.textColor};
 @media (max-width: 990px) {
font-size:${props => props.theme.fontSize.secondary};
}
`;

export const BoldText = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;


export const UnderlineLink = styled.a`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size: 1rem;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline !important;
  &:hover{
    color: ${props => props.theme.fontColors.primary};
  }
  @media (max-width: 990px) {
    font-size:${props => props.theme.fontSize.secondary};
    }
  `
export const NoResult = styled.div`
text-align:center;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.secondary};
font-style: ${props => props.theme.fontWeight.normal};
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
@media only screen and (min-width: 990px) {
  font-size: ${props => props.theme.fontSize.primary};
}
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? '50px' : '')};
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 20px;
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const WorkBookPrintWrap = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  margin-bottom: 1rem;
  height: 30px;
  z-index: 1;
  @media only screen and (min-width: 992px) {
    margin-bottom: 0;
  }
  .wrapper{
    display: flex;
    align-items: flex-start;
    @media only screen and (min-width: 992px) {
      transform: translateY(50px);
    }
  }
`;

export const SearchTableLabel = styled(TableLabel)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor} !important;
  @media (max-width: 990px) {
  padding-bottom:5px;
  }
`;

export const CustomTable = styled(GrantsTable)`
.ant-table-thead {
  tr {
    th { 
      padding: ${props => props.sidePadding ? "10px 16px" : "0px 16px 10px 0px"};
    }
  }
}
  overflow-y: scroll;
  border-top: 1px solid ${props => props.theme.colors.border};
  margin-top: 20px;
  @media only print {
    margin: 0;
  }
`;

export const SubSectionLabelWDivider = styled(SubSectionLabel)`
  color: ${props => props.theme.fontColors.headingColor};
  padding: 0 0 20px 0;
  @media only screen and (min-width: 992px) {
    padding: 15px 0 30px 0;
    border-top: 1px solid ${props => props.theme.colors.border};
    margin-top: 20px;
  }
`;